import React from 'react';

const SendFollowRequest = (props) => {
    

    const openApp = () => {
        $("#appModal").modal('show');
    }
    return (
        <li className="checkApp">
            <a href={void(0)} onClick={openApp}>
                <img src={(props.is_following == 1) ? "/assets/images/rss_icon_blue.png" : "/assets/images/rss_icon.png"} />
            </a>
        </li>
    );
} 

export default SendFollowRequest;